var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSpinner = function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      margin: "auto",
      background: "none",
      display: "block",
      shapeRendering: "auto"
    },
    viewBox: "30 30 40 40",
    preserveAspectRatio: "xMidYMid"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(0 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#db0015"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.6806722689075628s",
    repeatCount: "indefinite"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(21.176470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#d39400"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.57563025210084s",
    repeatCount: "indefinite"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(42.35294117647059 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#25862a"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.4705882352941175s",
    repeatCount: "indefinite"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(63.529411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#b7001e"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.3655462184873948s",
    repeatCount: "indefinite"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(84.70588235294117 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#e01f10"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.260504201680672s",
    repeatCount: "indefinite"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(105.88235294117646 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#830025"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.1554621848739495s",
    repeatCount: "indefinite"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(127.05882352941177 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#e85200"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-1.0504201680672267s",
    repeatCount: "indefinite"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(148.23529411764707 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#cd0068"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.9453781512605041s",
    repeatCount: "indefinite"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(169.41176470588235 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#0098d1"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.8403361344537814s",
    repeatCount: "indefinite"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(190.58823529411765 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#ffad00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.7352941176470588s",
    repeatCount: "indefinite"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(211.76470588235293 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#f68e00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.630252100840336s",
    repeatCount: "indefinite"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(232.94117647058823 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#cd7d00"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.5252100840336134s",
    repeatCount: "indefinite"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(254.11764705882354 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#3d6726"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.4201680672268907s",
    repeatCount: "indefinite"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(275.29411764705884 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#0064ae"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.315126050420168s",
    repeatCount: "indefinite"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(296.47058823529414 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#3a9927"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.21008403361344535s",
    repeatCount: "indefinite"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(317.6470588235294 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#003d76"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "-0.10504201680672268s",
    repeatCount: "indefinite"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(338.8235294117647 50 50)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 49,
    y: 40.5,
    rx: 0.66,
    ry: 0.66,
    width: 2,
    height: 3,
    fill: "#002555"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "opacity",
    values: "1;0",
    keyTimes: "0;1",
    dur: "1.7857142857142856s",
    begin: "0s",
    repeatCount: "indefinite"
  })))));
};
export default SvgSpinner;